$(document).ready(function(){
  
    (function($) {

      var allPanels = $('.accordion > dd');

    $('.accordion > dt > h5').click(function() {
     $(this).parent().toggleClass('active');
      $(this).parent().next().slideToggle();
      return false;
    });

  })(jQuery);
  
  $('.accordion > dt:not(.first) > h5').trigger('click');
  
    $('a[href^="#"]').click(function (event) {
    event.preventDefault();

    $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top - 100,
        easing: 'ease-out'
      
    }, 500);
  
  });

})